import React from 'react'
import { Typography } from 'antd'
import { Color } from '../../Common/Color'

const { Title, Paragraph, Text } = Typography

export default function CGUPage () {
  return (
    <div style={{ flex: 1, padding: '2em 10%', maxWidth: '1200px', margin: '0 auto', backgroundColor: Color.white }}>
      <Typography>
        <Title level={1}>CONDITIONS GÉNÉRALES D&apos;UTILISATION</Title>
        <Paragraph>
          <Text>Site internet : www.laboxmedicale.com</Text><br />
          <Text>Dernière mise à jour : 01/01/2026</Text>
        </Paragraph>

        <Title level={2}>ARTICLE 1 — MENTIONS LÉGALES</Title>
        <Paragraph>
          Le site www.laboxmedicale.com (ci-après « le Site ») est édité par :
        </Paragraph>
        <Paragraph>
          <ul>
            <li>Raison sociale : EXO SANTE</li>
            <li>Forme juridique : SAS</li>
            <li>Capital social : 10 000 €</li>
            <li>Siège social : 536 Avenue de l&apos;Hermitage, zone du Berret 30200 Bagnols-sur-Cèze</li>
            <li>RCS : 920 633 294 R.C.S. Nimes</li>
            <li>SIRET : 920 633 294 00011</li>
            <li>Numéro de TVA intracommunautaire : FR76920633294</li>
            <li>Directeur de la publication : Christophe Tichadou</li>
            <li>Téléphone : 04 48 24 01 28</li>
            <li>E-mail : contact@laboxmedicale.com</li>
          </ul>
        </Paragraph>
        <Paragraph>
          Hébergeur du site :
          <ul>
            <li>Raison sociale : Evolix</li>
            <li>Adresse : 37, rue Guibal Pôle Média Belle de Mai 13003 Marseille</li>
            <li>Téléphone : 04 91 05 92 54</li>
          </ul>
        </Paragraph>

        <Title level={2}>ARTICLE 2 — OBJET</Title>
        <Paragraph>
          Les présentes Conditions Générales d&apos;Utilisation (ci-après « CGU ») ont pour objet de définir les modalités et conditions d&apos;accès et d&apos;utilisation du Site par tout utilisateur (ci-après « l&apos;Utilisateur »).
        </Paragraph>
        <Paragraph>
          L&apos;accès au Site implique l&apos;acceptation pleine et entière des présentes CGU. L&apos;Utilisateur qui n&apos;accepte pas ces conditions doit renoncer à utiliser le Site.
        </Paragraph>

        <Title level={2}>ARTICLE 3 — DESCRIPTION DES SERVICES</Title>
        <Paragraph>
          Le Site permet de réserver une Box Médicale afin d&apos;accéder à une borne de téléconsultation pour un rendez-vous médical avec un médecin.
        </Paragraph>
        <Paragraph>
          Les informations présentées sur le Site sont fournies à titre indicatif et ne se substituent en aucun cas à un avis médical professionnel.
        </Paragraph>

        <Title level={2}>ARTICLE 4 — ACCÈS AU SITE</Title>
        <Paragraph>
          Le Site est accessible gratuitement depuis tout appareil disposant d&apos;un accès à Internet. Les frais liés à l&apos;accès au Site (connexion Internet, équipement informatique) restent à la charge de l&apos;Utilisateur.
        </Paragraph>
        <Paragraph>
          L&apos;éditeur met en œuvre les moyens raisonnables pour assurer un accès continu au Site, mais ne saurait être tenu responsable en cas d&apos;interruption, qu&apos;elle soit due à une maintenance, une mise à jour, un cas de force majeure ou toute autre circonstance indépendante de sa volonté.
        </Paragraph>

        <Title level={2}>ARTICLE 5 — COMPTE UTILISATEUR</Title>
        <Paragraph>
          L&apos;accès à certains services peut nécessiter la création d&apos;un compte utilisateur. L&apos;Utilisateur s&apos;engage à :
          <ul>
            <li>Fournir des informations exactes, complètes et à jour lors de sa réservation ;</li>
            <li>Informer immédiatement l&apos;éditeur de toute annulation de sa réservation.</li>
          </ul>
        </Paragraph>
        <Paragraph>
          L&apos;éditeur se réserve le droit de suspendre ou supprimer la réservation en cas de non-respect des présentes CGU.
        </Paragraph>

        <Title level={2}>ARTICLE 6 — PROPRIÉTÉ INTELLECTUELLE</Title>
        <Paragraph>
          L&apos;ensemble des contenus présents sur le Site (textes, images, photographies, logos, vidéos, graphismes, icônes, sons, logiciels, etc.) est protégé par les lois françaises et internationales relatives à la propriété intellectuelle.
        </Paragraph>
        <Paragraph>
          Toute reproduction, représentation, modification, distribution ou exploitation, même partielle, de ces contenus est strictement interdite sans l&apos;autorisation écrite préalable de l&apos;éditeur.
        </Paragraph>

        <Title level={2}>ARTICLE 7 — RESPONSABILITÉ</Title>
        <Title level={4}>7.1 — Informations à caractère médical</Title>
        <Paragraph>
          Les informations diffusées sur le Site le sont à titre purement informatif. Elles ne constituent en aucun cas un diagnostic, une consultation médicale ou une recommandation de traitement. L&apos;Utilisateur est invité à consulter un professionnel de santé qualifié pour toute question relative à sa santé.
        </Paragraph>
        <Paragraph>
          L&apos;éditeur décline toute responsabilité quant à l&apos;utilisation qui pourrait être faite de ces informations.
        </Paragraph>
        <Title level={4}>7.2 — Contenus et liens externes</Title>
        <Paragraph>
          Le Site peut contenir des liens vers des sites tiers. L&apos;éditeur n&apos;exerce aucun contrôle sur ces sites et décline toute responsabilité quant à leur contenu, leurs pratiques ou leur disponibilité.
        </Paragraph>
        <Title level={4}>7.3 — Limitation de responsabilité</Title>
        <Paragraph>
          L&apos;éditeur ne saurait être tenu responsable des dommages directs ou indirects résultant de l&apos;utilisation du Site, notamment en cas d&apos;interruption de service, de virus informatique ou d&apos;erreur dans les contenus publiés.
        </Paragraph>

        <Title level={2}>ARTICLE 8 — PROTECTION DES DONNÉES PERSONNELLES</Title>
        <Paragraph>
          L&apos;éditeur s&apos;engage à respecter la réglementation en vigueur relative à la protection des données personnelles, en particulier le Règlement Général sur la Protection des Données (RGPD — Règlement UE 2016/679) et la loi Informatique et Libertés du 6 janvier 1978 modifiée.
        </Paragraph>
        <Title level={4}>8.1 — Données collectées</Title>
        <Paragraph>
          Les données personnelles susceptibles d&apos;être collectées sur le Site sont les suivantes :
          <ul>
            <li>Nom, prénom</li>
            <li>Adresse e-mail</li>
            <li>Numéro de téléphone</li>
            <li>Adresse postale</li>
            <li>Données de navigation (cookies, adresse IP)</li>
            <li>Age</li>
          </ul>
        </Paragraph>
        <Title level={4}>8.2 — Finalités du traitement</Title>
        <Paragraph>
          Les données collectées sont utilisées pour :
          <ul>
            <li>La gestion des réservations et la relation patient ;</li>
            <li>L&apos;envoi de newsletters et d&apos;informations sur l&apos;utilisation de la Box Médicale (avec consentement préalable) ;</li>
            <li>L&apos;amélioration du Site et des services ;</li>
            <li>Le respect des obligations légales.</li>
          </ul>
        </Paragraph>
        <Title level={4}>8.3 — Base légale</Title>
        <Paragraph>
          Les traitements reposent sur : le consentement de l&apos;Utilisateur, l&apos;exécution d&apos;une réservation de la Box Médicale, l&apos;intérêt légitime de l&apos;éditeur ou le respect d&apos;une obligation légale, selon les cas.
        </Paragraph>
        <Title level={4}>8.4 — Durée de conservation</Title>
        <Paragraph>
          Les données personnelles sont conservées pendant une durée d&apos;un an (12 mois) proportionnée aux finalités pour lesquelles elles sont traitées, et conformément à la réglementation applicable.
        </Paragraph>
        <Title level={4}>8.5 — Droits de l&apos;Utilisateur</Title>
        <Paragraph>
          Conformément au RGPD, l&apos;Utilisateur dispose des droits suivants :
          <ul>
            <li>Droit d&apos;accès : obtenir la confirmation du traitement de ses données et en obtenir une copie ;</li>
            <li>Droit de rectification : demander la correction de données inexactes ou incomplètes ;</li>
            <li>Droit à l&apos;effacement : demander la suppression de ses données dans les cas prévus par la loi ;</li>
            <li>Droit à la limitation : demander la limitation du traitement de ses données ;</li>
            <li>Droit à la portabilité : recevoir ses données dans un format structuré et lisible par machine ;</li>
            <li>Droit d&apos;opposition : s&apos;opposer au traitement de ses données pour des motifs légitimes ;</li>
            <li>Droit de retirer son consentement à tout moment, lorsque le traitement est fondé sur le consentement.</li>
          </ul>
        </Paragraph>
        <Paragraph>
          Pour exercer ces droits, l&apos;Utilisateur peut adresser sa demande à : DPO@laboxmedicale.com ou par courrier à l&apos;adresse du siège social.
        </Paragraph>
        <Paragraph>
          En cas de litige, l&apos;Utilisateur peut introduire une réclamation auprès de la Commission Nationale de l&apos;Informatique et des Libertés (CNIL) — www.cnil.fr.
        </Paragraph>
        <Title level={4}>8.6 — Délégué à la protection des données (DPO)</Title>
        <Paragraph>
          Christophe Tichadou<br />
          Contact : DPO@laboxmedicale.com
        </Paragraph>

        <Title level={2}>ARTICLE 9 — COOKIES</Title>
        <Paragraph>
          Le Site utilise des cookies et traceurs pour assurer son bon fonctionnement et mesurer son audience.
        </Paragraph>
        <Title level={4}>9.1 — Types de cookies utilisés</Title>
        <Paragraph>
          <ul>
            <li><strong>Cookies essentiels</strong> — Finalité : Fonctionnement technique du Site — Durée : Durée de la session</li>
            <li><strong>Cookies analytiques</strong> — Finalité : Mesure d&apos;audience (ex. : Google Analytics)</li>
            <li><strong>Cookies marketing</strong> — Finalité : Publicité ciblée, le cas échéant</li>
          </ul>
        </Paragraph>
        <Title level={4}>9.2 — Gestion des cookies</Title>
        <Paragraph>
          Lors de sa première visite, l&apos;Utilisateur est informé de l&apos;utilisation de cookies via un bandeau de consentement. Il peut accepter, refuser ou personnaliser ses choix à tout moment.
        </Paragraph>
        <Paragraph>
          L&apos;Utilisateur peut également gérer les cookies depuis les paramètres de son navigateur :
          <ul>
            <li>Chrome : https://support.google.com/chrome/answer/95647</li>
            <li>Firefox : https://support.mozilla.org/fr/kb/activer-desactiver-cookies</li>
            <li>Safari : https://support.apple.com/fr-fr/guide/safari/sfri11471/mac</li>
          </ul>
        </Paragraph>

        <Title level={2}>ARTICLE 10 — OBLIGATIONS DE L&apos;UTILISATEUR</Title>
        <Paragraph>
          L&apos;Utilisateur s&apos;engage à :
          <ul>
            <li>Utiliser le Site conformément à sa destination et aux présentes CGU ;</li>
            <li>Ne pas tenter de porter atteinte au bon fonctionnement du Site ;</li>
            <li>Ne pas collecter ni exploiter les données personnelles d&apos;autres utilisateurs ;</li>
            <li>Ne pas diffuser de contenu illicite, diffamatoire, injurieux ou contraire à l&apos;ordre public ;</li>
            <li>Respecter les droits de propriété intellectuelle de l&apos;éditeur et des tiers.</li>
          </ul>
        </Paragraph>

        <Title level={2}>ARTICLE 11 — MODIFICATION DES CGU</Title>
        <Paragraph>
          L&apos;éditeur se réserve le droit de modifier les présentes CGU à tout moment. Les modifications prennent effet dès leur publication sur le Site. Il est conseillé à l&apos;Utilisateur de consulter régulièrement cette page.
        </Paragraph>
        <Paragraph>
          La date de dernière mise à jour est indiquée en haut du document.
        </Paragraph>

        <Title level={2}>ARTICLE 12 — DROIT APPLICABLE ET JURIDICTION COMPÉTENTE</Title>
        <Paragraph>
          Les présentes CGU sont soumises au droit français.
        </Paragraph>
        <Paragraph>
          En cas de litige, les parties s&apos;engagent à rechercher une solution amiable avant toute action judiciaire. À défaut, les tribunaux compétents de Bagnols-sur-Cèze seront seuls compétents.
        </Paragraph>

        <Title level={2}>ARTICLE 13 — CONTACT</Title>
        <Paragraph>
          Pour toute question relative aux présentes CGU, l&apos;Utilisateur peut contacter l&apos;éditeur :
          <ul>
            <li>Par e-mail : contact@laboxmedicale.com</li>
            <li>Par courrier : 536 Avenue de l&apos;Hermitage, zone du Berret 30200 Bagnols-sur-Cèze</li>
            <li>Par téléphone : 04 48 24 01 28</li>
          </ul>
        </Paragraph>
      </Typography>
    </div>
  )
}
